"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const TileDescriptionExpandable_1 = require("./TileDescriptionExpandable");
const index_1 = require("../index");
const TileDescription = ({ description, tileType, tileShape, isDescriptionExpandable, showMoreBtnLabel, showLessBtnLabel, }) => {
    if (!description) {
        return null;
    }
    const THROTTLE_TIME = 200;
    const [isMobileScreen, setMobileScreen] = React.useState((0, app_1.isMobile)());
    React.useEffect(() => {
        const handleResize = () => {
            setMobileScreen((0, app_1.isMobile)());
        };
        window.addEventListener('resize', (0, app_1.throttle)(handleResize, THROTTLE_TIME));
        return () => {
            window.removeEventListener('resize', (0, app_1.throttle)(handleResize, THROTTLE_TIME));
        };
    }, []);
    const descriptionRef = (0, app_1.useExternalIcon)('mt-0.5 self-center text-[length:inherit]');
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isMobileScreen && isDescriptionExpandable ? ((0, jsx_runtime_1.jsx)(TileDescriptionExpandable_1.TileDescriptionExpandable, { description: description, showMoreBtnLabel: showMoreBtnLabel, showLessBtnLabel: showLessBtnLabel })) : ((0, jsx_runtime_1.jsx)("div", { ref: descriptionRef, className: (0, app_1.cn)('body-md text-secondary prose prose-danfoss [&_*]:!font-sans', tileShape === index_1.TileShapeEnum.Wide && 'sm:line-clamp-2 [&_*]:sm:m-0', tileType === index_1.TileTypeEnum.SabaCourses && 'sm:line-clamp-3'), children: (0, app_1.StringToHTML)(description) })) }));
};
exports.TileDescription = TileDescription;
